var _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.9624,
    cy: 28.9624,
    r: 28.9624,
    fill: "url(#paint0_linear_14974_335)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8716 21.7966H31.1982V27.171H43.6631V23.5881C43.6631 23.113 43.4743 22.6573 43.1384 22.3213C42.8024 21.9854 42.3468 21.7966 41.8716 21.7966ZM16.7914 21.7966C16.3163 21.7966 15.8607 21.9854 15.5247 22.3213C15.1887 22.6573 15 23.113 15 23.5881V27.171H27.5401V21.7966H16.7914ZM16.7914 28.9624V41.5025C16.7914 41.9776 16.9802 42.4333 17.3161 42.7692C17.6521 43.1052 18.1078 43.2939 18.5829 43.2939H27.5401V28.9624H16.7914ZM40.0802 43.2939C40.5553 43.2939 41.011 43.1052 41.3469 42.7692C41.6829 42.4333 41.8716 41.9776 41.8716 41.5025V28.9624H31.1982V43.2939H40.0802ZM29.3298 19.9909H29.3351C29.3331 19.9954 29.3319 20.0002 29.3315 20.0052H36.4973C38.9713 20.0052 40.0802 18.8013 40.0802 17.318C40.0802 15.8347 38.9713 14.6309 36.4973 14.6309C34.181 14.6309 32.3573 15.6735 31.123 16.8827C30.5664 16.5475 29.9294 16.3692 29.2796 16.3668C28.6311 16.3668 28.031 16.5495 27.5043 16.8469C26.2718 15.652 24.4588 14.6309 22.1658 14.6309C19.6918 14.6309 18.5829 15.8347 18.5829 17.318C18.5829 18.8013 19.6918 20.0052 22.1658 20.0052H29.3315L29.3298 19.9909ZM38.2888 17.318C38.2888 18.0579 37.3142 18.2137 36.4973 18.2137H32.4289C32.4146 18.1887 32.4021 18.1618 32.3877 18.1385C33.2978 17.2535 34.6772 16.4223 36.4973 16.4223C37.3142 16.4223 38.2888 16.5782 38.2888 17.318ZM20.3743 17.318C20.3743 16.5782 21.3489 16.4223 22.1658 16.4223C23.9465 16.4223 25.2972 17.2195 26.2073 18.074C26.1786 18.1188 26.1571 18.1672 26.1302 18.2137H22.1658C21.3489 18.2137 20.3743 18.0579 20.3743 17.318Z",
    fill: "url(#paint1_linear_14974_335)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3315 20.0052C29.3319 20.0002 29.3331 19.9954 29.3351 19.9909H29.3298L29.3315 20.0052ZM29.3315 20.0052H36.4973C38.9713 20.0052 40.0802 18.8013 40.0802 17.318C40.0802 15.8347 38.9713 14.6309 36.4973 14.6309C34.181 14.6309 32.3573 15.6735 31.123 16.8827C30.5664 16.5475 29.9294 16.3692 29.2796 16.3668C28.6311 16.3668 28.031 16.5495 27.5043 16.8469C26.2718 15.652 24.4588 14.6309 22.1658 14.6309C19.6918 14.6309 18.5829 15.8347 18.5829 17.318C18.5829 18.8013 19.6918 20.0052 22.1658 20.0052H29.3315ZM41.8716 21.7966H31.1982V27.171H43.6631V23.5881C43.6631 23.113 43.4743 22.6573 43.1384 22.3213C42.8024 21.9854 42.3468 21.7966 41.8716 21.7966ZM16.7914 21.7966C16.3163 21.7966 15.8607 21.9854 15.5247 22.3213C15.1887 22.6573 15 23.113 15 23.5881V27.171H27.5401V21.7966H16.7914ZM16.7914 28.9624V41.5025C16.7914 41.9776 16.9802 42.4333 17.3161 42.7692C17.6521 43.1052 18.1078 43.2939 18.5829 43.2939H27.5401V28.9624H16.7914ZM40.0802 43.2939C40.5553 43.2939 41.011 43.1052 41.3469 42.7692C41.6829 42.4333 41.8716 41.9776 41.8716 41.5025V28.9624H31.1982V43.2939H40.0802ZM38.2888 17.318C38.2888 18.0579 37.3142 18.2137 36.4973 18.2137H32.4289C32.4146 18.1887 32.4021 18.1618 32.3877 18.1385C33.2978 17.2535 34.6772 16.4223 36.4973 16.4223C37.3142 16.4223 38.2888 16.5782 38.2888 17.318ZM20.3743 17.318C20.3743 16.5782 21.3489 16.4223 22.1658 16.4223C23.9465 16.4223 25.2972 17.2195 26.2073 18.074C26.1786 18.1188 26.1571 18.1672 26.1302 18.2137H22.1658C21.3489 18.2137 20.3743 18.0579 20.3743 17.318Z",
    stroke: "url(#paint2_linear_14974_335)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14974_335",
    x1: 28.9624,
    y1: 0,
    x2: 28.9624,
    y2: 57.9248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#180B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070617"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14974_335",
    x1: 29.3315,
    y1: 14.6309,
    x2: 29.3315,
    y2: 43.2939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#180B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070617"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14974_335",
    x1: 29.3315,
    y1: 14.6309,
    x2: 29.3315,
    y2: 43.2939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B892ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7300FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFree);
export default __webpack_public_path__ + "static/media/free.82200c033552d960eed49180de8775de.svg";
export { ForwardRef as ReactComponent };